export function translateErrors(value: string) {
    const errorsList: {[key: string]: string} = {
      'order.customerMobileNumber.invalid': 'شماره همراه سفارش‌دهنده اشتباه است',
      'order.customerMobileNumber.invalid.size':
        'شماره همراه سفارش‌دهنده اشتباه است',
      'order.customerPhoneNumber.invalid': 'شماره تماس سفارش‌دهنده اشتباه است',
      'order.customerPhoneNumber.invalid.size':
        'شماره تماس سفارش‌دهنده اشتباه است',
      'order.customerAddress.invalid.size': 'آدرس سفارش‌دهنده اشتباه است',
      'order.customerAddress.invalid': 'آدرس سفارش‌دهنده اشتباه است',
      'order.customerProvince.invalid.size': 'استان سفارش‌دهنده اشتباه است',
      'order.customerCity.invalid.size': 'شهر سفارش‌دهنده اشتباه است',
      'order.customerZipCode.invalid': 'کد پستی سفارش‌دهنده اشتباه است',
      'order.customerZipCode.invalid.size': 'کد پستی سفارش‌دهنده اشتباه است',
      'order.customerNationalCode.invalid.size': 'کد ملی سفارش‌دهنده اشتباه است',
      'order.customerNationalCode.invalid': 'کد ملی سفارش‌دهنده اشتباه است',
      'order.customerName.invalid.size': 'نام سفارش‌دهنده اشتباه است',
      'order.trackingCode.invalid.size': 'کد پیگیری اشتباه است',
      'order.trackingCode.invalid': 'کد پیگیری اشتباه است',
      'order.trackingCode.exists': 'کد پیگیری اشتباه است',
      'order.deliveryDate.notExist': 'تاریخ تحویل اشتباه است',
      'order.deliveryStartTime.notExist': 'ساعت شروع تحویل اشتباه است',
      'order.deliveryEndTime.notExist': 'ساعت پایان تحویل اشتباه است',
      'orderItem.productCode.notProvided': 'کد کالا اشتباه است',
      'orderItem.productCode.notExists': 'کد کالا اشتباه است',
      'orderItem.variantCode.notProvided': 'کد تنوع کالای کالا اشتباه است',
      'product.categoryCode.invalid': 'کد دسته‌بندی کالا اشتباه است',
      'product.categoryCode.invalid.size': 'کد دسته‌بندی کالا اشتباه است',
      'product.name.invalid.size': 'نام کلا اشتباه است',
      'product.name.notExist': 'نام کلا اشتباه است',
      'product.code.invalid': 'کد کلا اشتباه است',
      'product.code.notExist': 'کد کلا اشتباه است',
      'product.code.invalid.size': 'کد کلا اشتباه است',
      'product.codingType.notExist': 'نوع کلا اشتباه است',
      'product.weight.invalid': 'وزن کلا اشتباه است',
      'product.length.invalid': 'طول کلا اشتباه است',
      'product.width.invalid': 'عرض کلا اشتباه است',
      'product.height.invalid': 'ارتفاع کلا اشتباه است',
      'product.shippingWeight.invalid': 'وزن حمل و نقل کلا اشتباه است',
      'product.shippingLength.invalid': 'طول حمل و نقل کلا اشتباه است',
      'product.shippingWidth.invalid': 'عرض حمل و نقل کلا اشتباه است',
      'product.shippingHeight.invalid': 'ارتفاع حمل و نقل کلا اشتباه است',
      'product.variant.seller.code.invalid': 'کد فروشنده کلا اشتباه است',
      'product.variant.seller.code.notExists': 'کد فروشنده کلا اشتباه است',
      'product.variant.provider.code.invalid': 'کد تامین‌کننده کلا اشتباه است',
      'product.variant.provider.code.notExists': 'کد تامین‌کننده کلا اشتباه است',
      'product.variant.code.must.filled': 'کد تنوع کالا اشتباه است',
      'orderItem.variantCode.notExists': 'کد تنوع کالا اشتباه است',
      'product.code.exist': 'این کد کالا قبلا ثبت شده است',
      'product.name.exist': 'این نام کالا قبلا ثبت شده است',
      'duplicated.variantCode': 'آیتم تکراری',
      'not acceptable': 'کمبود موجودی',
      'Delivery Date Is Before now': 'تاریخ ارسال منقضی شده است',
      'order.deliveryType.notExist': 'نوع ارسال اشتباه است',
      'order.weight.invalid': 'وزن کالا اشتباه است',
      'order.packageCode.invalid': 'packageCode اشتباه است',
      'duplicated.sku.id': 'کالا تکراری است',
      'inventoryItem.unitCost.invalid': "قیمت کالا اشتباه است",
      "parcelItem.productCode.notProvided": "کدکالا وارد نشده است",
      "parcelItem.productCode.notExists": "کدکالا وارد نشده است",
      "product.warehouseId.invalid": "شناسه انبار اشتباه است",
      // "product.suppliable.invalid": "مقدار suppliable اشتباه است"
    };
    return errorsList[value] ? errorsList[value] : value;
}

export default translateErrors;